import React, { createContext } from 'react'
import { observable, action, configure, runInAction } from 'mobx'



class homeStore{
    @observable lineTotal = 6
    @observable columnTotal = 6

    @action setColumnTotal = (params) => {
        console.log(params)
        this.columnTotal = params
    }
}

export default createContext( new homeStore)

